export default __webpack_public_path__ + "static/media/lock.f1be96ee.svg";